import React from 'react'
import { connect } from 'react-redux'
import useAuth from 'components/auth/useAuth'
import { RedirectWithQueryParams } from 'components'
import {
  ExistingMembershipDialog,
  UnfoundMembershipDialog,
} from 'member-portal/components'
import { AllMembershipsType } from 'types'
import { selectors } from 'memberships/reducer'
import {
  PATH,
  getAccountIdentifier,
  hasMembershipHistory,
  makeMemberApplicationPath,
  makeMarketingSitePath,
} from 'config'

const propTypes = {
  allMemberships: AllMembershipsType,
}

function NewOrRenew({ allMemberships = null }) {
  const { isAuthenticated, logout, user } = useAuth()

  const memberAccountId = getAccountIdentifier(user)
  const hasMemberAccountId = isAuthenticated && memberAccountId
  const isUnboundMember = !hasMembershipHistory(allMemberships?.memberships)

  const logoutAndReturnToApp = () =>
    logout({
      logoutParams: { returnTo: makeMarketingSitePath(PATH.SEATOW_LOGOUT) },
    })

  // Verify that the logged-in user has access to the member portal. If they
  // already have an account but their membership is unbound (no SF data),
  // let them know to sign up for a new membership. If they have an account
  // and are not unbound, let them know they already have a membership that
  // exists. Otherwise send them directly to sign up for a membership.
  if (hasMemberAccountId && isUnboundMember) {
    return (
      <UnfoundMembershipDialog logoutAndReturnToApp={logoutAndReturnToApp} />
    )
  }

  if (hasMemberAccountId && !isUnboundMember) {
    return <ExistingMembershipDialog />
  }

  return (
    <RedirectWithQueryParams
      to={makeMemberApplicationPath(PATH.NEW_MEMBER_QUESTIONNAIRE)}
    />
  )
}

NewOrRenew.propTypes = propTypes

function mapStateToProps(state) {
  return { allMemberships: selectors.allMemberships(state) }
}

export default connect(mapStateToProps)(NewOrRenew)
